import { Component, Input} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';
// import html2canvas from 'html2canvas';

@Component({
  selector: 'view-extended-report',
  templateUrl: './view-extended-report.component.html'
})

export class ViewExtendedReportComponent{
  isModal: boolean=true;
  disabledSaveAsPng: boolean = false;
  constructor(private activeModal: NgbActiveModal,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private exportService: ExportServiceService
  ) { }
  @Input() selectedField: any = null;
  @Input() type: string = '';
  @Input() graphData:any = null;

  saveAsPng(tooltip: MatTooltip, graph: string){
    let documentObject:any = document;
    // let that = this;
    // that.disabledSaveAsPng = true;
    tooltip.hide();
    let config: any = {
      documentPrint: documentObject.querySelector(graph),
      name: 'Captura',
      successCallback: (uploadResponse:any, blob:any) => {
        let dataBlob = new Blob([blob], { type: 'image/png' });
        let data = [new ClipboardItem({ [dataBlob.type]: dataBlob })];
        navigator.clipboard.write(data)
            .then(() => {}, (err) => console.log(err));
        this.loader.closeLoader(['export-file']);
        // that.disabledSaveAsPng = false;
        tooltip.message = this.translate.instant('results-report.image-captured');
        tooltip.show();
        setTimeout(() => {
          tooltip.hide();
        }, 1500);
        setTimeout(() => {
          tooltip.message = this.translate.instant('results-report.capture-image');
        }, 1700);
      }
    };
    this.exportService.convertToImg(config);
  }

  // saveAsPng(tooltip: MatTooltip, graph: string){
  //   let documentObject:any = document;
  //   let that = this;
  //   that.disabledSaveAsPng = true;
  //   tooltip.hide();
  //   setTimeout(() => {
  //     html2canvas(documentObject.querySelector(graph))
  //       .then(function(canvas) {
  //           canvas.toBlob((blob:any)=>{
  //               let data = [new ClipboardItem({ [blob.type]: blob })];
  //               navigator.clipboard.write(data)
  //                   .then(() => {}, (err) => console.log(err));
  //           });
  //     }).then(() => {
  //       that.disabledSaveAsPng = false;
  //       tooltip.message = this.translate.instant('results-report.image-captured');
  //       tooltip.show();
  //       setTimeout(() => {
  //         tooltip.message = this.translate.instant('results-report.capture-image');
  //         tooltip.hide();
  //       }, 2000);
  //     });
  //   }, 100);
  // }

  handleDismiss() {
    this.activeModal.close({result:'cancel'});
  };

  handleAccept() {
    this.activeModal.close({
        result: 'ok'
      });
  };

}
